import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Users } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const WaitlistCounter = () => {
  const [count, setCount] = useState(null);
  const [remainingSpots, setRemainingSpots] = useState(null);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/waitlist/count`);
        setCount(response.data.count);
        setRemainingSpots(response.data.remaining_spots);
      } catch (error) {
        // Default values if API fails
        setCount(487);
        setRemainingSpots(13);
      }
    };

    fetchCount();
    // Refresh every 30 seconds
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, []);

  if (count === null) return null;

  const percentFilled = ((500 - remainingSpots) / 500) * 100;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.8, duration: 0.6 }}
      className="inline-flex flex-col items-center gap-2 md:gap-3 px-4 md:px-6 py-3 md:py-4 rounded-xl md:rounded-2xl glass ice-hover"
      data-testid="waitlist-counter"
    >
      <div className="flex items-center gap-2 md:gap-3">
        <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-[#00D4FF] to-[#8B5CF6] flex items-center justify-center">
          <Users size={16} className="text-white md:w-5 md:h-5" />
        </div>
        <div className="text-left">
          <div className="flex items-baseline gap-1">
            <span className="font-['Unbounded'] text-xl md:text-2xl font-black gradient-text">
              {remainingSpots}
            </span>
            <span className="text-[#A1A1AA] text-xs md:text-sm font-medium">
              / 500 spots left
            </span>
          </div>
          <p className="text-[10px] md:text-xs text-[#A1A1AA]">
            {count} people already joined
          </p>
        </div>
      </div>
      
      {/* Progress bar */}
      <div className="w-full h-1.5 md:h-2 bg-white/10 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-[#00D4FF] to-[#8B5CF6] rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${percentFilled}%` }}
          transition={{ duration: 1.5, ease: "easeOut", delay: 1 }}
        />
      </div>
      
      {/* Urgency indicator */}
      {remainingSpots <= 50 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex items-center gap-1.5 md:gap-2 text-[10px] md:text-xs"
        >
          <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-[#FF3366] animate-pulse" />
          <span className="text-[#FF3366] font-medium">
            {remainingSpots <= 10 ? "Almost sold out!" : "Filling fast!"}
          </span>
        </motion.div>
      )}
    </motion.div>
  );
};

export default WaitlistCounter;
